import * as React from 'react';
import clsx from 'clsx';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
var styles = {
  "root": "Card-root_1IiaW",
  "panel": "Card-panel_18GAy",
  "inline": "Card-inline_Ch6ih"
};
var stylesContent = {
  "root": "CardContent-root_3djk8",
  "panel": "CardContent-panel_2MmAq",
  "inline": "CardContent-inline_6h4Gi",
  "padded": "CardContent-padded_3XxYG"
};
var stylesFooter = {
  "root": "CardFooter-root_1QbP2 Widget-widgetFluidHeight_3_KT_"
};
function Card({
  children,
  footer,
  className,
  variant = 'panel',
  padded = true,
  classes,
  ...extraProps
}) {
  const classOf = key => classes?.[key] ?? '';
  const rootClasses = clsx(styles.root, styles[variant], className, classOf('root'));
  const contentClasses = clsx(stylesContent.root, stylesContent[variant], padded && stylesContent.padded, classOf('content'));
  const footerClasses = clsx(stylesFooter.root, classOf('footer'));
  return /*#__PURE__*/_jsxs("div", {
    className: rootClasses,
    ...extraProps,
    children: [/*#__PURE__*/_jsx("div", {
      className: contentClasses,
      children: children
    }), footer ? /*#__PURE__*/_jsx("footer", {
      className: footerClasses,
      children: footer
    }) : null]
  });
}
export default Card;